// 9fbef606107a605d69c0edbcd8029e5d
const SLASH = '/';
/**
 * Normalize CC Number with *
 *
 * @param {string} value
 * @returns {string} Normalized CC Number with *
 */

export const handleEditCreditCardNumber = (value) => {
  const startWithAsterisk = value.startsWith('*');

  if (startWithAsterisk || value === '') {
    return '';
  }

  return value;
};

/**
 * Normalize CC ExpMonthYear to handle /
 * - Should not allow multiple /
 * - Should allow removing /
 *
 * @param {string} value
 * @param {string} prevValue
 * @returns {string} formattedValue (Normalized ExpMonthYear)
 */
export const normalizeCCExpMonthYear = (value, prevValue) => {
  let formattedValue = value?.match(/\//g)?.length > 1 ? prevValue : value;
  if (prevValue?.length === 1 && value?.length === 2 && !value?.includes(SLASH)) {
    formattedValue = `${formattedValue}${SLASH}`;
  } else if (prevValue?.length === 3 && value?.length === 4 && !value?.includes(SLASH)) {
    formattedValue = `${formattedValue.substring(0, 2)}${SLASH}${formattedValue.substring(4, 2)}`;
  }
  return formattedValue;
};
